{
  "core_fields": {
    "first_name": "Imię",
    "last_name": "Nazwisko",
    "nick_name": "Pseudonim",
    "full_name": "Imię i nazwisko",
    "role": "Rola",
    "import_id": "ID importu",
    "contact_type": "Typ kontaktu",
    "resource_type_id": "Typ zasobu",
    "represented_by_id": "Reprezentowany przez",
    "profile_picture": "Zdjęcie profilowe",
    "rates": "Stawki",
    "tags": "Tagi",
    "groups": "Grupy",
    "locations": "Lokalizacje",
    "emails": "Adresy e‑mail",
    "websites": "Strony internetowe",
    "phone_numbers": "Numery telefonów",
    "socials": "Social media",
    "pronouns": "Zaimki",

    "code": "Kod",
    "icon": "Ikona",
    "title": "Tytuł",
    "production_type_id": "Typ produkcji",
    "production_template_id": "Szablon produkcji",
    "production_date": "Data produkcji",
    "shotflow_instance": "Instancja Shotflow",
    "status_id": "Status",
    "description": "Opis",
    "color": "Kolor",
    "timezone": "Strefa czasowa",
    "events": "Harmonogram",
    "production_locations": "Lokalizacje",
    "budget_amount": "Kwota budżetu",
    "estimated_total": "Szacowany koszt",
    "actual_total": "Rzeczywisty koszt",
    "budget_expenses": "Wydatki budżetowe",
    "budget_expenses.name": "Nazwa",
    "budget_expenses.description": "Opis",
    "budget_expenses.estimate": "Szacunek",
    "budget_expenses.archived": "Zarchiwizowane",
    "budget_expenses.group_id": "Grupa",
    "budget_expenses.slot_category_id": "Kategoria",
    "budget_expenses.expenses": "Koszty",
    "budget_expenses.expenses.booking_id": "Rezerwacja",
    "budget_expenses.expenses.booking.resource_id": "Zasób",
    "budget_expenses.expenses.commit_vendor": "Dostawca",
    "budget_expenses.expenses.commit": "Zadeklarowane",
    "budget_expenses.expenses.created_at": "Data utworzenia",
    "budget_expenses.expenses.updated_at": "Data aktualizacji",
    "budget_expenses.expenses.slot_category_id": "Kategoria",
    "budget_expenses.expenses.receipts": "Paragony",
    "resourcing_at": "Data przydziału zasobów",
    "ready_at": "Data gotowości",
    "completed_at": "Data ukończenia",
    "cancelled_at": "Data anulowania",

    "booking_type_id": "Typ rezerwacji",
    "rate": "Stawka",
    "note": "Notatka",
    "contracts": "Umowy",
    "invoices": "Faktury",
    "submitted_date": "Data złożenia",
    "agreed_date": "Data uzgodnienia",
    "pencilled_at": "Wstępnie zaplanowano",
    "confirmed_at": "Data potwierdzenia",

    "createdAt": "Data utworzenia",
    "updatedAt": "Data aktualizacji",
    "archived": "Zarchiwizowane",
    "user_id": "Właściciel",

    "bookings": "Rezerwacje",

    "public_id": "ID publiczne",
    "status": "Status",
    "public_title": "Publiczny tytuł",
    "public_description": "Publiczny opis",
    "confirmation_text": "Tekst potwierdzenia",
    "enable_notifications": "Włącz powiadomienia",
    "published": "Opublikowane",
    "deadline": "Termin",
    "public": "Publiczny",
    "expanded": "Rozszerzone",
    "public_feedback": "Publiczny feedback",
    "layout": "Układ",
    "enable_voting": "Włącz głosowanie",
    "enable_commenting": "Włącz komentowanie",

    "billing": "Rozliczenia",
    "social": "Social",
    "hard_drive": "Dysk twardy",
    "from_date": "Od daty",
    "to_date": "Do daty",
    "call_time": "Godzina zbiórki",

    "resource_slots": "Sloty zasobów",
    "resource": "Zasób",
    "resource_slot_assignments": "Przydziały slotów zasobów",

    "organisation": "Organizacja",
    "organisation_id": "Organizacja",
    "availability": "Dostępność",
    "all": "Wszystko",
    "published_at": "Data publikacji",
    "callsheet_date": "Data zbiórki"
  },
  "rate_intervals": {
    "DAILY": "Dziennie",
    "HOURLY": "Godzinowo",
    "FIXED": "Stała",
    "ITEM": "Za element"
  },
  "rateInput": {
    "currencyAria": "Waluta",
    "amountAria": "Kwota stawki",
    "intervalAria": "Jednostka rozliczenia",
    "quantityAria": "Ilość",
    "currencyTooltip": "Waluta używana dla tej stawki.",
    "amountTooltip": "Kwota stawki (przed ilością i opłatami).",
    "intervalTooltip": "Sposób rozliczenia stawki, np. godzinowo lub dziennie.",
    "multiplyTooltip": "Stawka jest mnożona przez ilość, aby uzyskać sumę wiersza.",
    "quantityTooltip": "Liczba jednostek, których dotyczy ta stawka."
  },
  "dynamicUi": {
    "fileField": {
      "dropFilesOrClick": "Upuść pliki tutaj, kliknij, aby wybrać, lub wklej",
      "acceptMimeImageAll": "obrazy",
      "acceptMimeVideoAll": "filmy",
      "acceptMimePdf": "dokumenty PDF",
      "weAccept": "Akceptujemy",
      "atLeastOneFileRequired": "Wymagany jest co najmniej jeden plik",
      "uploadFailed": "Wysyłanie nie powiodło się",
      "noFilesUploaded": "Brak przesłanych plików"
    }
  },
  "validation": {
    "required": "To pole jest wymagane",
    "url": "To nie jest poprawny link",
    "email": "To nie jest poprawny adres e-mail",
    "phone_number": "To nie jest poprawny numer telefonu"
  },
  "standard-date-filter": {
    "timestamp": {
      "last7Days": "Ostatnie 7 dni",
      "last30Days": "Ostatnie 30 dni",
      "last90Days": "Ostatnie 90 dni"
    },
    "scheduled": {
      "today": "Dzisiaj",
      "tomorrow": "Jutro",
      "nextWeek": "Następny tydzień",
      "nextMonth": "Następny miesiąc"
    },
    "custom": {
      "last7Days": "Ostatnie 7 dni",
      "last30Days": "Ostatnie 30 dni",
      "last90Days": "Ostatnie 90 dni",
      "today": "Dzisiaj",
      "tomorrow": "Jutro",
      "nextWeek": "Następny tydzień",
      "nextMonth": "Następny miesiąc"
    }
  },
  "AccountSettingsPronouns": {
    "sectionLabel": "Zasoby",
    "title": "Opcje zaimków",
    "description": "Określ, jakie etykiety zaimków są dostępne przy edycji osób (Individual, Talent, Agent).",
    "listTitle": "Dozwolone zaimki",
    "help": "Te wartości są sprawdzane przy zapisie zasobu. Przeciągnij uchwyt, aby zmienić kolejność; duplikaty są usuwane przy zapisie.",
    "dragHandleLabel": "Przeciągnij, aby zmienić kolejność",
    "optionPlaceholder": "np. Oni/Ich",
    "addOption": "Dodaj opcję",
    "remove": "Usuń",
    "save": "Zapisz",
    "saved": "Zapisano opcje zaimków",
    "saveFailed": "Nie udało się zapisać opcji zaimków"
  },
  "online_status": {
    "online": "Jesteś online",
    "offline": "Jesteś offline",
    "toast_offline": "Jesteś offline",
    "toast_online": "Połączenie przywrócone"
  },
  "enterprise": {
    "globalScopeLabel": "Globalne",
    "loadingWorkspaces": "Ładowanie przestrzeni roboczych…",
    "workspacesUnavailable": "Przestrzenie robocze niedostępne",
    "emptyWorkspaces": "Brak dostępnych przestrzeni roboczych",
    "emptyWorkspacesHint": "To nie powinno się zdarzyć. Skontaktuj się z pomocą techniczną.",
    "teamsSectionLabel": "Zespoły",
    "loadingTeams": "Ładowanie zespołów…",
    "teamsUnavailable": "Zespoły niedostępne",
    "emptyTeams": "Brak zespołów w tej przestrzeni roboczej",
    "emptyTeamsHint": "To nie powinno się zdarzyć. Skontaktuj się z pomocą techniczną.",
    "teamsSettingsLabel": "Ustawienia zespołu",
    "newTeam": "Nowy zespół",
    "newWorkspace": "Nowa przestrzeń robocza",
    "createWorkspace": "Utwórz przestrzeń roboczą",
    "createWorkspaceDescription": "Dodaj nową przestrzeń roboczą enterprise do organizacji.",
    "editWorkspace": "Edytuj przestrzeń roboczą",
    "editWorkspaceDescription": "Zaktualizuj nazwę i ikonę przestrzeni roboczej.",
    "createTeam": "Utwórz zespół",
    "createTeamDescription": "Dodaj nowy zespół w tej przestrzeni roboczej.",
    "editTeam": "Edytuj zespół",
    "editTeamDescription": "Zaktualizuj nazwę, ikonę i kolor zespołu.",
    "archive": "Archiwizuj",
    "unarchive": "Przywróć",
    "activeTab": "Aktywne",
    "archivedTab": "Zarchiwizowane",
    "emptyArchivedWorkspaces": "Brak zarchiwizowanych przestrzeni roboczych",
    "emptyArchivedTeams": "Brak zarchiwizowanych zespołów w tej przestrzeni",
    "edit": "Edytuj",
    "create": "Utwórz",
    "save": "Zapisz",
    "fieldName": "Nazwa",
    "fieldIcon": "Ikona",
    "fieldIconColor": "Kolor ikony",
    "pickIconColor": "Wybierz kolor",
    "iconUploadHint": "Upuść obraz, kliknij, aby przesłać, lub wklej",
    "uploadIcon": "Prześlij ikonę",
    "removeIcon": "Usuń",
    "iconUploadError": "Nie udało się przesłać ikony",
    "manageEntity": "Zarządzaj",
    "manageEnterprise": "Zarządzaj enterprise",
    "manageEnterpriseDescription": "Twórz, edytuj i archiwizuj przestrzenie robocze oraz zespoły w organizacji.",
    "workspacesTitle": "Przestrzenie robocze",
    "teamsTitle": "Zespoły",
    "teamsForWorkspace": "Zespoły w {{workspace}}",
    "selectWorkspaceHint": "Wybierz przestrzeń roboczą, aby zarządzać jej zespołami"
  },
  "resourceTypesAdmin": {
    "globalTitle": "Typy zasobów",
    "globalDescription": "Zarządzaj ogólnosystemowymi typami zasobów synchronizowanymi między przestrzeniami roboczymi.",
    "workspaceTitle": "Typy zasobów",
    "workspaceDescription": "Zarządzaj typami zasobów widocznymi w tej przestrzeni roboczej oraz jej polami.",
    "name": "Nazwa",
    "type": "Typ",
    "workspaces": "Przestrzenie robocze",
    "assignWorkspaces": "Zarządzaj przestrzeniami roboczymi",
    "searchWorkspaces": "Szukaj przestrzeni roboczych…",
    "openInWorkspace": "Otwórz ustawienia {{workspace}}",
    "workspacesTabHint": "Typy zasobów nie są domyślnie przypisane do przestrzeni roboczych. Włącz je tam, gdzie powinny być widoczne.",
    "workspacesSearchNoResults": "Nie znaleziono przestrzeni roboczych",
    "workspacesTabEmpty": "Brak przestrzeni roboczych w tej organizacji",
    "workspacesLoadError": "Nie udało się wczytać przestrzeni roboczych",
    "newResourceType": "Nowy typ zasobu",
    "createTitle": "Utwórz typ zasobu",
    "createDescription": "Utwórz typ zasobu dostępny w całej organizacji.",
    "fieldName": "Nazwa",
    "fieldIcon": "Ikona",
    "fieldMechanism": "Typ",
    "mechanismLockedHint": "Nie można edytować po utworzeniu.",
    "chooseIcon": "Wybierz ikonę",
    "active": "Aktywne",
    "inactive": "Nieaktywne",
    "activate": "Aktywuj",
    "deactivate": "Dezaktywuj",
    "activateFieldTitle": "Aktywować pole?",
    "activateFieldDescription": "Czy na pewno chcesz aktywować to pole?",
    "deactivateFieldTitle": "Dezaktywować pole?",
    "deactivateFieldDescription": "Czy na pewno chcesz dezaktywować to pole? Nie utracisz żadnych danych.",
    "edit": "Edytuj",
    "archive": "Archiwizuj",
    "unarchive": "Przywróć",
    "archiveSuccess": "Typ zasobu został zarchiwizowany",
    "unarchiveSuccess": "Typ zasobu został przywrócony",
    "enable": "Włącz w przestrzeni roboczej",
    "disable": "Wyłącz w przestrzeni roboczej",
    "enableSuccess": "Typ zasobu został włączony w przestrzeni roboczej",
    "disableSuccess": "Typ zasobu został wyłączony w przestrzeni roboczej",
    "disabledInWorkspaceTitle": "Ten typ zasobu jest wyłączony w {{workspace}}",
    "disabledInWorkspaceDescription": "Członkowie tej przestrzeni roboczej nie zobaczą zasobów tego typu, dopóki nie zostanie włączony.",
    "disableConfirmTitle": "Wyłączyć typy zasobów?",
    "disableConfirmDescription": "Wybrane typy zasobów nie będą już widoczne w tej przestrzeni roboczej. Nie utracisz żadnych danych.",
    "detailsTab": "Szczegóły",
    "detailsSaveSuccess": "Typ zasobu zapisany",
    "detailsSaveFailed": "Nie udało się zapisać typu zasobu",
    "fieldsTab": "Pola",
    "globalDetailSubtitle": "Edytuj ten typ zasobu dla wszystkich przestrzeni roboczych.",
    "workspaceDetailSubtitle": "Edytuj opcje tego typu zasobu specyficzne dla przestrzeni roboczej. Aby edytować pozostałe ustawienia, przejdź do strony globalnych typów zasobów.",
    "viewGlobalSettings": "Zobacz ustawienia globalne",
    "viewGlobalResourceTypes": "Zobacz globalne typy zasobów",
    "globalFieldsTitle": "Pola globalne",
    "globalFieldsHint": "Pola edytowane i dodawane tutaj zostaną zastosowane we wszystkich przestrzeniach roboczych. Aby edytować pola specyficzne dla przestrzeni roboczej, przejdź do jej ustawień.",
    "workspaceGlobalFieldsHint": "Pola globalne można edytować wyłącznie poza przestrzenią roboczą, w konfiguracji globalnej.",
    "configureGlobalFields": "Konfiguruj pola globalne",
    "workspaceFieldsTitle": "Pola: {{workspace}}",
    "workspaceFallbackName": "Przestrzeń robocza",
    "required": "Wymagane",
    "locked": "Zablokowane",
    "filterable": "Filtrowalne",
    "requiredEnabledToast": "Pole oznaczone jako wymagane",
    "requiredDisabledToast": "Pole nie jest już wymagane",
    "filterableEnabledToast": "Pole jest teraz filtrowalne",
    "filterableDisabledToast": "Pole nie jest już filtrowalne",
    "fieldPropertyUpdateError": "Nie udało się zaktualizować pola",
    "fieldType": "Typ",
    "addField": "Dodaj pole",
    "addFieldAssignPrompt": "Zostanie dodane do",
    "searchFields": "Szukaj pól…",
    "fieldsSearchNoResults": "Nie znaleziono pól",
    "dangerousActions": "Niebezpieczne akcje",
    "archiveSectionTitle": "Archiwizuj typ zasobu",
    "archiveSectionDescription": "Dane zostaną zachowane, ale użytkownicy we wszystkich przestrzeniach roboczych nie będą już widzieć tego typu zasobu",
    "unarchiveSectionTitle": "Przywróć typ zasobu",
    "unarchiveSectionDescription": "Przywróć ten typ zasobu, aby można go było ponownie włączać w przestrzeniach roboczych.",
    "entityNameSingular": "typ zasobu",
    "entityNamePlural": "typy zasobów",
    "fieldEntityNameSingular": "pole",
    "fieldEntityNamePlural": "pola",
    "batchArchiveSelected": "Archiwizuj wybrane",
    "batchUnarchiveSelected": "Przywróć wybrane",
    "batchActivateSelected": "Aktywuj wybrane",
    "batchDeactivateSelected": "Dezaktywuj wybrane",
    "batchActivateFieldsNone": "Brak pól do aktywowania",
    "batchDeactivateFieldsNone": "Zablokowane pola systemowe nie mogą zostać dezaktywowane",
    "batchEnableSelected": "Włącz wybrane",
    "batchDisableSelected": "Wyłącz wybrane",
    "reorderFields": "Zmień kolejność pola",
    "emptyActive": "Brak aktywnych typów zasobów",
    "emptyInactive": "Brak nieaktywnych typów zasobów",
    "emptyArchived": "Brak zarchiwizowanych typów zasobów",
    "emptyFields": "Brak pól",
    "emptyInactiveFields": "Brak nieaktywnych pól",
    "loadError": "Nie udało się wczytać tego typu zasobu",
    "localPreviewNote": "Włączanie w przestrzeniach roboczych i pola są zapisywane lokalnie w tej przeglądarce, dopóki backend ich nie obsłuży.",
    "assignResourceTypesAction": "Włącz typy zasobów",
    "assignResourceTypesTitle": "Włącz typy zasobów",
    "assignResourceTypesSearchPlaceholder": "Szukaj typów zasobów…",
    "assignResourceTypesSelectedCount": "Wybrano: {{count}}",
    "assignResourceTypesSelectPrompt": "Wybierz typy zasobów do włączenia w tej przestrzeni roboczej",
    "assignResourceTypesUnselectAll": "Odznacz wszystkie",
    "assignResourceTypesEmpty": "Wszystkie typy zasobów są już włączone w tej przestrzeni roboczej",
    "assignResourceTypesNoResults": "Nie znaleziono typów zasobów",
    "assignResourceTypesConfirm": "Włącz ({{count}})",
    "assignResourceTypesLoadError": "Nie udało się wczytać typów zasobów",
    "create": "Utwórz",
    "createFailed": "Nie udało się utworzyć typu zasobu",
    "unsavedChangesBeforeUnload": "Masz niezapisane zmiany!",
    "cancel": "Anuluj",
    "mechanisms": {
      "INDIVIDUAL": "Osoba",
      "ORGANIZATION": "Organizacja",
      "LOCATION": "Lokalizacja",
      "ITEM": "Przedmiot",
      "TALENT": "Talent",
      "AGENT": "Agent"
    }
  },
  "app_update": {
    "message": "Dostępna jest nowa wersja aplikacji.",
    "refresh": "Odśwież"
  },
  "app_crash": {
    "title": "Coś poszło nie tak",
    "description": "Aplikacja uległa awarii. Odśwież stronę i spróbuj ponownie lub skontaktuj się z nami po pomoc",
    "refresh": "Odśwież",
    "goToDashboard": "Przejdź do pulpitu",
    "errorLogLabel": "Szczegóły błędu"
  },
  "server_unreachable": {
    "bootstrap": {
      "title": "Nie udało się załadować aplikacji",
      "description_connection": "Nie udało się połączyć z serwerem. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Serwer zwrócił błąd podczas ładowania wymaganych danych. Spróbuj ponownie za chwilę."
    },
    "session": {
      "title": "Nie udało się załadować sesji",
      "description_connection": "Nie udało się połączyć z serwerem, aby wczytać ustawienia konta. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Nie udało się wczytać ustawień konta z powodu błędu serwera. Spróbuj ponownie za chwilę."
    },
    "sign_in": {
      "title": "Logowanie niedostępne",
      "description_connection": "Nie udało się połączyć w celu weryfikacji opcji logowania. Sprawdź połączenie i odśwież stronę.",
      "description_server": "Logowanie jest tymczasowo niedostępne z powodu błędu serwera. Spróbuj ponownie za chwilę."
    },
    "refresh": "Odśwież",
    "goToDashboard": "Przejdź do pulpitu",
    "errorLogLabel": "Szczegóły błędu"
  },
  "not_found": {
    "title": "Nie możemy znaleźć tego, czego szukasz",
    "description": "Sprawdź, czy link jest poprawny i czy jesteś zalogowany. Jeśli problem nadal występuje, jesteśmy do dyspozycji!",
    "contactSupport": "Skontaktuj się z pomocą",
    "goToDashboard": "Przejdź do pulpitu",
    "contact": {
      "title": "Nie znaleziono kontaktu",
      "description": "Ten kontakt mógł zostać zarchiwizowany albo link jest nieprawidłowy"
    },
    "production": {
      "title": "Nie znaleziono produkcji",
      "description": "Ta produkcja mogła zostać zarchiwizowana albo link jest nieprawidłowy"
    },
    "callout": {
      "title": "Nie znaleziono ogłoszenia",
      "description": "To ogłoszenie mogło zostać zarchiwizowane albo link jest nieprawidłowy"
    },
    "callsheet": {
      "title": "Nie znaleziono callsheetu",
      "description": "Ten callsheet mógł zostać zarchiwizowany albo link jest nieprawidłowy"
    },
    "shortlist": {
      "title": "Nie znaleziono shortlisty",
      "description": "Ta shortlista mogła zostać zarchiwizowana albo link jest nieprawidłowy"
    }
  }
}
